export default "__VITE_ASSET__D6t_oGOh__"